export default __webpack_public_path__ + "static/media/AB_Result.71f26c06.png";